// replacement for lodash _.get() -- really only lodash function we consistently use - DHR 2024-07-25
// eslint-disable-next-line
import {ReactNode} from "react";

export function getValueByPath(
  obj: object,
  path: string,
  defaultValue: string | number | string[] | number[] | ReactNode = ''
) {
  // console.log(obj, path);
  if (obj === undefined || path === undefined) return defaultValue;
  return path.split('.').reduce((acc, key) => acc?.[key], obj) ?? defaultValue;
}

export function setValueByPath(obj, path: string, value: number | string) {
  const pathArray = path.split('.');
  let current = obj;

  for (let i = 0; i < pathArray.length - 1; i++) {
    const key = pathArray[i];

    // Create nested objects if they don't exist
    if (!current[key]) {
      current[key] = {};
    }

    current = current[key];
  }

  current[pathArray[pathArray.length - 1]] = value;
}

export const roundOf = (n, p) => {
  // https://stackoverflow.com/a/49862458
  const n1 = n * Math.pow(10, p + 1);
  const n2 = Math.floor(n1 / 10);
  if (n1 >= n2 * 10 + 5) {
    return (n2 + 1) / Math.pow(10, p);
  }
  return n2 / Math.pow(10, p);
};

export const handleError = (err) => {
  if (err?.response?.status === 400) {
    console.error('ERROR', err?.response?.data?.errors);
    err?.response?.data?.errors?.forEach((error: string) => {
      alert('API Error: ' + error);
    });
  } else {
    if (err?.response?.status) console.log('ERROR CODE', err?.response?.status);
    if (err?.response?.data) console.log('ERROR', err?.response?.data);
  }
};

export function truncateString(str, maxLength, trailing = 0) {
  if (str === undefined || !str) return '';
  if (typeof str === 'number') {
    return str.toString();
  }
  if (str.length <= maxLength) {
    return str;
  } else if (trailing) {
    const strLen = str.length;
    return (
      str.slice(0, maxLength - trailing) +
      '...' +
      str.slice(strLen - trailing, strLen)
    );
  } else {
    return str.slice(0, maxLength) + '...';
  }
}

export function getDaysSinceDate(date) {
  const now = new Date();
  const then = new Date(date);
  const timeDiffInMinutes = now.getTime() - then.getTime();
  return Math.floor(timeDiffInMinutes / (1000 * 3600 * 24));
}
